import fetch from 'isomorphic-fetch';
import { authContext } from './AzureAd';
import { apiHost } from './config';

const createParam = (method, header, body, token) => {
  let _headers = header;
  if (_headers === undefined) {
    _headers = new Headers({
      'Accept': 'application/json;charset=UTF-8',
      'Content-Type': 'application/json;charset=UTF-8'
    });
  }

  // Add AAD token to header
  if (token) {
    // console.info('token:', token);
    _headers.append('Authorization', 'Bearer ' + token);
  } else {
    console.err('No token!');
    return;
  }

  let _param = {};
  let _method = method.toUpperCase();
  if (_method === 'GET' || _method === 'HEAD') {
    _param = {
      method: _method,
      headers: _headers
    };
  } else {
    _param = {
      method: _method,
      headers: _headers,
      body: body
    };
  }

  return _param;
}

/**
 * Using default header; input JSON; output JSON.
 */
export const authFetch = (method, url, body, callback) => {

  // Acquire token for Files resource.
  authContext.acquireToken(authContext.config.clientId, function (error, token) {

    // console.log('token =====' +token)

    // Handle ADAL Errors.
    if (error) {
      console.err('ADAL error occurred: ' + error);
      return;
    }

    fetch(apiHost + url, createParam(method, undefined, body, token)).then((response) => {
      // console.log('response.status', response.status);
      // console.log('response.body', response.body);
      if (!response.ok) {
        throw Error(response.status, response.statusText);
      }
      return response.json();
    }).then((json) => {
      // console.log('JSON', json);
      if (callback) {
        callback(json);
      }
    }).catch(function (err) {
      console.log('Fetch Error: ', err);
    });
  });
};

/**
 * File upload; input multipart/form-data (auto detect); output JSON.
 */
export const authUpload = (method, url, body, callback) => {

  // Acquire token for Files resource.
  authContext.acquireToken(authContext.config.clientId, function (error, token) {

    // Handle ADAL Errors.
    if (error) {
      console.err('ADAL error occurred: ' + error);
      return;
    }

    let headers = new Headers({
      'Accept': 'application/json;charset=UTF-8'
    });

    fetch(apiHost + url, createParam(method, headers, body, token)).then((response) => {
      // console.log('response.status', response.status);
      // console.log('response.body', response.body);
      return response.json();
    }).then((json) => {
      // console.log('JSON', json);
      if (callback) {
        callback(json);
      }
    }).catch(function (err) {
      console.log('Fetch Error: ', err);
    });
  });
};



// WEBPACK FOOTER //
// ./src/AuthFetch.js